<div class="customer-page">
  <div class="customer-form">
    <div class="customer-form__header">
      {{ "kopetro.customerForm.heading" | translate }}
    </div>

    <div class="customer-form__body">
      <div class="customer-form__body__stepper">
        <div class="customer-form__body__heading">
          {{
            "kopetro.customerForm.step" + (stepper.selectedIndex + 1) + "Title"
              | translate
          }}
        </div>
        <div class="customer-form__body__heading--sm">
          {{
            "kopetro.customerForm.page" + (stepper.selectedIndex + 1) + "Title"
              | translate
          }}
        </div>

        <mat-stepper
          #stepper
          [linear]="true"
          (selectionChange)="onStepChange($event, stepper)"
        >
          <mat-step [stepControl]="memberFormGroup">
            <form [formGroup]="memberFormGroup" #memberForm="ngForm">
              <ng-template matStepLabel>
                <span></span>
              </ng-template>

              <div class="customer-form__body__wrapper">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.name" | translate }}</mat-label>
                  <input matInput formControlName="name" />
                </mat-form-field>

                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.newIC" | translate }}</mat-label>
                    <input matInput formControlName="identityNo" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{
                      "common.emailAddress" | translate
                    }}</mat-label>
                    <input required matInput formControlName="email" />
                    <mat-error
                      *ngIf="memberFormGroup.get('email').errors?.required"
                      >Emel adalah wajib</mat-error
                    >
                    <mat-error
                      *ngIf="memberFormGroup.get('email').errors?.email"
                      >Emel tidak sah</mat-error
                    >
                  </mat-form-field>
                </div>

                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.staffNo" | translate }}</mat-label>
                    <input
                      required
                      matInput
                      autocomplete="off"
                      formControlName="staffNo"
                    />
                    <mat-error
                      *ngIf="memberFormGroup.get('staffNo').errors?.required"
                      >{{ "common.staffNo" | translate }} adalah
                      wajib</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.telNo" | translate }}</mat-label>
                    <ngx-mat-intl-tel-input
                      [enableSearch]="false"
                      [preferredCountries]="['my']"
                      formControlName="mobileNo"
                      [required]="true"
                    >
                    </ngx-mat-intl-tel-input>
                    <mat-error
                      *ngIf="memberFormGroup.get('mobileNo').errors?.required"
                      >{{ "common.telNo" | translate }} adalah wajib</mat-error
                    >
                  </mat-form-field>
                </div>

                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.memberNo" | translate }}</mat-label>
                    <input required matInput formControlName="memberNo" />
                    <mat-error
                      *ngIf="memberFormGroup.get('memberNo').errors?.required"
                      >{{ "common.memberNo" | translate }} adalah
                      wajib</mat-error
                    >
                  </mat-form-field>

                  <div>
                    <mat-form-field
                      appearance="outline"
                      style="width: 70%"
                      class="left-field"
                    >
                      <mat-label>{{
                        "common.officeTelNo" | translate
                      }}</mat-label>
                      <input
                        matInput
                        autocomplete="off"
                        maxlength="20"
                        formControlName="officeTelNo"
                        mask="000000000000"
                      />
                    </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      style="width: 30%"
                      class="right-field"
                    >
                      <mat-label>{{
                        "common.officeTelExt" | translate
                      }}</mat-label>
                      <input
                        matInput
                        autocomplete="off"
                        formControlName="officeTelExt"
                        maxlength="6"
                        mask="000000"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="section-container mt-sm">
                <div class="title-sec">
                  <div class="title-f">
                    {{ "common.officeAddressTitle" | translate }}
                  </div>
                  <div class="divider"></div>
                </div>
              </div>

              <div class="customer-form__body__wrapper">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.addressLineOne" | translate
                  }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="officeAddressLineOne"
                  />
                  <mat-error
                    *ngIf="
                      memberFormGroup.get('officeAddressLineOne').errors
                        ?.required
                    "
                    >{{ "common.addressLineOne" | translate }} adalah
                    wajib</mat-error
                  >
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.addressLineTwo" | translate
                  }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="officeAddressLineTwo"
                  />
                  <mat-error
                    *ngIf="
                      memberFormGroup.get('officeAddressLineTwo').errors
                        ?.required
                    "
                    >{{ "common.addressLineTwo" | translate }} adalah
                    wajib</mat-error
                  >
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.city" | translate }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="officeCity"
                  />
                  <mat-error
                    *ngIf="memberFormGroup.get('officeCity').errors?.required"
                    >{{ "common.city" | translate }} adalah wajib</mat-error
                  >
                </mat-form-field>

                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.postcode" | translate }}</mat-label>
                    <input
                      required
                      matInput
                      autocomplete="off"
                      formControlName="officePostcode"
                      maxlength="5"
                      mask="00000"
                    />
                    <mat-error
                      *ngIf="
                        memberFormGroup.get('officePostcode').errors?.required
                      "
                      >Postcode Pejabat adalah wajib</mat-error
                    >
                    <mat-error
                      *ngIf="
                        memberFormGroup.get('officePostcode').errors
                          ?.invalidPostcode
                      "
                      >{{ "error.invalidPostcode" | translate }}</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.state" | translate }}</mat-label>
                    <mat-select formControlName="officeState">
                      <mat-option
                        *ngFor="let item of stateList"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        memberFormGroup.get('officeState').errors?.required
                      "
                      >{{ "common.state" | translate }} adalah wajib</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="section-container mt-sm">
                <div class="title-sec">
                  <div class="title-f">
                    {{ "common.homeAddressTitle" | translate }}
                  </div>
                  <div class="divider"></div>
                </div>
              </div>

              <div class="customer-form__body__wrapper">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.addressLineOne" | translate
                  }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="address"
                  />
                  <mat-error
                    *ngIf="memberFormGroup.get('address').errors?.required"
                    >{{ "common.addressLineOne" | translate }} adalah
                    wajib</mat-error
                  >
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.addressLineTwo" | translate
                  }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="address2"
                  />
                  <mat-error
                    *ngIf="memberFormGroup.get('address2').errors?.required"
                    >{{ "common.addressLineTwo" | translate }} adalah
                    wajib</mat-error
                  >
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.city" | translate }}</mat-label>
                  <input
                    required
                    matInput
                    autocomplete="off"
                    formControlName="city"
                  />
                  <mat-error
                    *ngIf="memberFormGroup.get('city').errors?.required"
                    >{{ "common.city" | translate }} adalah wajib</mat-error
                  >
                </mat-form-field>

                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.postcode" | translate }}</mat-label>
                    <input
                      required
                      matInput
                      autocomplete="postcode"
                      formControlName="postcode"
                      mask="00000"
                    />
                    <mat-error
                      *ngIf="memberFormGroup.get('postcode').errors?.required"
                      >Postcode adalah wajib</mat-error
                    >
                    <mat-error
                      *ngIf="
                        memberFormGroup.get('postcode').errors?.invalidPostcode
                      "
                      >{{ "error.invalidPostcode" | translate }}</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.state" | translate }}</mat-label>
                    <mat-select formControlName="state">
                      <mat-option
                        *ngFor="let item of stateList"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="memberFormGroup.get('state').errors?.required"
                      >{{ "common.state" | translate }} adalah wajib</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="button-wrapper">
                <button
                  mat-flat-button
                  matStepperNext
                  [disabled]="memberFormGroup.invalid"
                >
                  {{ "common.next" | translate }}
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="renewalFormGroup">
            <form [formGroup]="renewalFormGroup" #renewalForm="ngForm">
              <ng-template matStepLabel>
                <span></span>
              </ng-template>

              <div class="customer-form__body__wrapper">
                <div class="input-wrapper">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "common.plateNo" | translate }}</mat-label>
                    <input matInput formControlName="vehicleNo" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{
                      "common.roadtaxExpiryDate" | translate
                    }}</mat-label>
                    <input
                      required
                      matInput
                      [matDatepicker]="picker"
                      formControlName="roadtaxExpiryDate"
                      readonly
                      (click)="picker.open()"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="input-wrapper items-center">
                  <div>{{ "common.totalAmount" | translate }}</div>
                  <mat-form-field appearance="outline">
                    <span matPrefix>RM&nbsp;</span>
                    <input
                      matInput
                      type="text"
                      formControlName="totalAmt"
                      [value]="
                        renewalFormGroup.get('totalAmt')?.value
                          | number : '1.2-2'
                      "
                    />
                  </mat-form-field>
                </div>

                <div class="input-wrapper items-center">
                  <div>{{ "common.stampDuty" | translate }} KOPETRO</div>
                  <mat-form-field appearance="outline">
                    <span matPrefix>RM&nbsp;</span>
                    <input
                      matInput
                      type="text"
                      formControlName="stampDuty"
                      [value]="
                        renewalFormGroup.get('stampDuty')?.value
                          | number : '1.2-2'
                      "
                    />
                  </mat-form-field>
                </div>

                <div class="input-wrapper items-center">
                  <div>
                    {{
                      "common.insuranceRoadtaxRenewalApplicationAmt" | translate
                    }}
                  </div>
                  <mat-form-field appearance="outline">
                    <span matPrefix>RM&nbsp;</span>
                    <input
                      matInput
                      type="text"
                      formControlName="insuranceRoadtaxRenewalApplicationAmt"
                      autocomplete="off"
                      [value]="
                        renewalFormGroup.get(
                          'insuranceRoadtaxRenewalApplicationAmt'
                        )?.value | number : '1.2-2'
                      "
                    />
                  </mat-form-field>
                </div>

                <div class="input-wrapper items-center">
                  <div>{{ "common.monthlyInstalmentAmt" | translate }}</div>
                  <mat-form-field appearance="outline">
                    <span matPrefix>RM&nbsp;</span>
                    <input
                      matInput
                      type="text"
                      formControlName="monthlyInstalmentAmt"
                      autocomplete="off"
                      [value]="
                        renewalFormGroup.get('monthlyInstalmentAmt')?.value
                          | number : '1.2-2'
                      "
                    />
                  </mat-form-field>
                </div>

                <div class="input-wrapper items-center">
                  <div
                    [innerHTML]="'common.instalmentMonths' | translate"
                  ></div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="instalmentMonths">
                      <mat-option *ngFor="let num of months" [value]="num">
                        {{ num }} {{ "common.month" | translate }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="button-wrapper">
                <button mat-stroked-button matStepperPrevious>
                  {{ "common.back" | translate }}
                </button>
                <button
                  mat-flat-button
                  matStepperNext
                  [disabled]="renewalFormGroup.invalid"
                >
                  {{ "common.next" | translate }}
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="docFormGroup">
            <form [formGroup]="docFormGroup" #docForm="ngForm">
              <ng-template matStepLabel>
                <span></span>
              </ng-template>

              <div class="customer-form__body__doc">
                <div class="title-wrapper">
                  <mat-icon>info</mat-icon>
                  <div>
                    {{ "kopetro.customerForm.docRequirement" | translate }}
                  </div>
                </div>

                <ul>
                  <li *ngFor="let num of docRequirements" [value]="num">
                    {{
                      "kopetro.customerForm.docRequirement" + num | translate
                    }}
                  </li>
                </ul>
              </div>

              <div class="customer-form__body__upload">
                <div class="upload-container">
                  <div class="upload-wrapper">
                    <img src="/assets/icons/upload-icon-black.svg" />

                    <div class="upload-title">
                      {{ "kopetro.customerForm.uploadTitle" | translate }}
                    </div>
                    <div class="upload-desc">
                      {{ "kopetro.customerForm.uploadTitle2" | translate }}
                    </div>

                    <input
                      required
                      #fileInput
                      name="payslip"
                      type="file"
                      [accept]="acceptFile"
                      (change)="handleFileInput($event)"
                      style="display: none"
                      multiple
                    />

                    <button
                      mat-flat-button
                      type="button"
                      class="upload-button"
                      (click)="onTriggerFile()"
                    >
                      <label class="cursor-pointer">{{
                        "kopetro.customerForm.chooseFile" | translate
                      }}</label>
                    </button>
                  </div>

                  <div class="upload-wrapper" *ngIf="payslip.length > 0">
                    <div
                      class="upload-file"
                      *ngFor="let p of payslip; let i = index"
                    >
                      <div class="upload-label">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span class="underlined-blue">
                          {{ p.name }}
                        </span>
                      </div>
                      <button
                        mat-icon-button
                        class="icon-container"
                        (click)="deleteFile(i)"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-wrapper">
                <button mat-stroked-button matStepperPrevious>
                  {{ "common.back" | translate }}
                </button>
                <button
                  mat-flat-button
                  matStepperNext
                  [disabled]="payslip.length < 3 || docFormGroup.invalid"
                >
                  {{ "common.next" | translate }}
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="termsFormGroup">
            <form
              [formGroup]="termsFormGroup"
              #termsForm="ngForm"
              (ngSubmit)="onSubmit()"
            >
              <ng-template matStepLabel>
                <span></span>
              </ng-template>

              <div class="customer-form__body__terms">
                <div class="title-wrapper">
                  <mat-icon>info</mat-icon>
                  <span
                    class="terms-title"
                    [innerHTML]="'kopetro.customerForm.termsTitle' | translate"
                  ></span>
                </div>

                <div
                  [innerHTML]="'kopetro.customerForm.termsTitle2' | translate"
                ></div>

                <ol>
                  <li *ngFor="let num of terms" [value]="num">
                    {{ "kopetro.customerForm.terms" + num | translate }}
                  </li>
                </ol>
              </div>

              <div class="customer-form__body__sign">
                <div>
                  <div>{{ "kopetro.customerForm.signature" | translate }}</div>
                  <mat-form-field appearance="outline" class="signature-input">
                    <input
                      required
                      matInput
                      type="text"
                      formControlName="signature"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>

                <div class="empty-div"></div>

                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "kopetro.customerForm.date" | translate
                  }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker2"
                    formControlName="dateSigned"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="button-wrapper">
                <button mat-stroked-button matStepperPrevious>
                  {{ "common.back" | translate }}
                </button>
                <button mat-flat-button [disabled]="termsFormGroup.invalid">
                  {{ "common.submit" | translate }}
                </button>
              </div>

              <!-- <div class="customer-form__body__officeuse">
                <div class="officeuse-title">
                  {{ "kopetro.customerForm.officeUse" | translate }}
                </div>

                <div class="flex-box">
                  <div style="width: calc(100% / 3);">
                    <div style="margin-bottom: 60px;">{{ "kopetro.customerForm.provided" | translate }}</div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.name" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.date" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div style="width: calc(100% / 3);">
                    <div style="margin-bottom: 60px;">{{ "kopetro.customerForm.checked" | translate }}</div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.name" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.date" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div style="width: calc(100% / 3);">
                    <div style="margin-bottom: 60px;">{{ "kopetro.customerForm.approved" | translate }}</div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.name" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                    <div class="info">
                      <div>{{ "kopetro.customerForm.date" | translate }}:</div>
                      <div class="line"></div>
                    </div>
                  </div>
                </div>
              </div> -->
            </form>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </div>
</div>
